<template>
  <div class="gp-date-picker-normal">
    <el-date-picker
      ref="datePickerRef"
      v-model="dateList"
      :picker-options="getPickerOptions()"
      :popper-class="readonly ? 'date-picker-confirm-hidden' : ''"
      :default-value="defaultValue"
      type="dates"
      value-format="timestamp"
      placeholder="选择一个或多个日期"
      @change="changeDate()" />
  </div>
</template>

<script>
import { parseTime } from '@/filters'
export default {
  props: {
    readonly: { type: Boolean, default: true },
    activityId: { type: String, default: '' },
    selectedDateList: { type: Array, default: () => [] },
    themeEndTime: { type: Number, default: 0 },
    themeStartTime: { type: Number, default: 0 }
  },
  data() {
    return {
      dateList: [],
      disabledDateList: [],
      defaultValue: '',
      row:{},
    }
  },
  methods: {
    showDatePicker(dateList, row) {
      this.row = row
      this.dateList = dateList || []
      this.dateList.sort((a, b) => {
        return a < b ? -1 : 1
      })
      let dateStr = ''
      if(this.dateList[0]) dateStr = parseTime(this.dateList[0],'{y}-{m}-{d}').slice(0,8) + '01'
      else dateStr = parseTime(new Date(),'{y}-{m}-{d}').slice(0,8) + '01'
      this.defaultValue = new Date(dateStr.replace(/-/g, '/'))
      this.getPickerOptions()
      this.$refs.datePickerRef.focus()
    },
    hideDatePicker(){
      this.$refs.datePickerRef.hidePicker()
    },
    getPickerOptions() {
      return {
        disabledDate: (data) => {
          if (this.readonly) {
            return true
          } else {
            if (data < this.themeStartTime || data > this.themeEndTime) {
              return true
            }
            if (this.disabledDateList.length !== 0) {
              for (const item of this.disabledDateList) {
                if (item === data) {
                  return true
                }
              }
            }
            return false
          }
        },
        shortcuts: [{
          text: '选择当月',
          onClick:(...arr) => this.handleClick('click',31, ...arr)
        },{
          text: '取消选择当月',
          onClick:(...arr) => this.handleClick('unclick',31, ...arr)
        }, {
          text: '全选',
          onClick:this.handleClickAll
        }]
      }
    },
    handleClickAll(){
      const start = this.themeStartTime 
      const end = this.themeEndTime
      const date = 3600*24*1000
      const selectedList = []
      for(let i = 0;((i*date)+start)<=end;i++){
        selectedList.push((i*date)+start)
      }
      const dateList = this.dateList.concat(selectedList)
      this.dateList = Array.from(new Set(dateList))
    },
    handleClick(type,day,picker){
      const date = picker.date
      const selectedList = []
      for (let i = 0; i < day; i++) {
        const str = parseTime(date.getTime() + 3600 * 1000 *24* i,'{y}-{m}-{d}')
        const monthStr = str.split('-')
        const month = Number(monthStr[1]) -1
        if(month===picker.month){
          const d = date.getTime() + 3600 * 1000 *24* i
          if(d >= this.themeStartTime && d <= this.themeEndTime){
            selectedList.push(d) 
          }
        }
      }
      if(type==='click'){
        const dateList = this.dateList.concat(selectedList)
        this.dateList = Array.from(new Set(dateList))     
      }else {
        const dateList = this.dateList.filter(item=>{
          return selectedList.indexOf(item)===-1
        })
        this.dateList = Array.from(new Set(dateList))
      }
    },
    changeDate(val) {
        //this.$refs.datePickerRef.focus()
        this.dateList = Array.from(new Set(this.dateList))
        const date = this.dateList.map(item=>{
          return parseTime(item,'{y}-{m}-{d}')
        })
        this.$emit('handleChangeDate', date,this.activityId,this.row)
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
